module.exports = [
  'Associates Degree',
  "Bachelor's Degree",
  "Master's Degree",
  'Doctoral Degree',
  'Pre-doctoral Fellowship',
  'Post-doctoral Fellowship',
  'Psychology Internship',
  'Medical Residency',
  'Psychology Residency',
  'Certificate Program',
  'Professional Training',
];
